import { render } from "./InputActions.vue?vue&type=template&id=53cc1930&scoped=true&ts=true"
import script from "./InputActions.vue?vue&type=script&lang=ts"
export * from "./InputActions.vue?vue&type=script&lang=ts"

import "./InputActions.vue?vue&type=style&index=0&id=53cc1930&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cc1930"]])

export default __exports__